import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../_ui-core_/components/ui-spinner/ui-spinner';
import style from './page.css?inline';

@customElement('unload-page')
export class UnloadPage extends LitElement {
  static readonly styles = unsafeCSS(style);

  connectedCallback(): void {
    super.connectedCallback();
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        // This page was restored from the bfcache.
        // => reload page as we don't want to restore this state
        window.location.reload();
      }
    });
  }

  render() {
    return html`
      <div class="bg">
        <ui-spinner></ui-spinner>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'unload-page': UnloadPage;
  }
}
